import React from 'react';
import '../App.css';
// import Header from '../Components/Header';
import Home from './Home';
// import Footer from '../Components/Footer';


function IndexPage() {
  return (
    <div className="App">
      <div className="content-wrap">
        {/* <Header /> */}
        <Home />
      </div>
     
    </div>
  );
}

export default IndexPage;
